<template>

  <v-layout
    column
    align-center
    v-scroll="searchMore"
  >
    <v-col
      cols="9"
      class="mt-8 ml-0"
    >
      <div id="main">

        <v-row :class="{'ml-n12':$vuetify.breakpoint.mdAndUp}">
          <span class="mb-7 text-right display-1 font-weight-bold grey--text text--darken-1">
            {{$vuetify.lang.t('$vuetify.MODALIDADES')}}</span>
        </v-row>

        <v-row
          id="filtro"
          class="pl-2 ml-0 grey lighten-5"
        >
          <v-col
            cols="4"
            class="pl-4"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.BUSCAR')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="searchText"
                dense
                label="Regular"
                :placeholder="$vuetify.lang.t('$vuetify.MODALIDADE_CONTRATO')"
                single-line
                solo
                max-width="200"
                append-icon="mdi-magnify"
                @click:append="search()"
                @keypress.enter="search()"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col class="mt-7 ml-3">
            <TooltipButton
              v-if="$hasPermission('MODALIDADES-NOVA', [])"
              :label="$vuetify.lang.t('$vuetify.NOVA_MODALIDADE')"
              :message="$vuetify.lang.t('$vuetify.NOVA_MODALIDADE')"
              :event="createModalidade"
              :mobile="$vuetify.breakpoint.xs"
              :isText=false
            ></TooltipButton>
          </v-col>

        </v-row>

        <v-row
          class="pl-2 pr-2"
          style="margin-left:-2px;"
        >

          <v-expansion-panels class="ma-1">

            <v-expansion-panel
              v-for="(modalidade, i) in modalidades"
              :key="i"
              hide-actions
              :disabled="disabled"
            >

              <v-expansion-panel-header style="z-index:1000;">
                <v-row
                  align="center"
                  no-gutters
                >

                  <v-col
                    v-show="!$vuetify.breakpoint.xs"
                    sm="5"
                    md="4"
                  >
                    <strong
                      class="subtitle-2 font-weight-bold"
                      v-html="modalidade.modalidade"
                    ></strong>
                  </v-col>

                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>

                <v-card-subtitle
                  v-if="modalidade.contrato"
                  class="caption mt-n8 ml-n4"
                >{{'Cód. SAP: ' + modalidade.contrato.numeroContratoSap}} |
                  {{'Cód. Tpz: '+  modalidade.contrato.numeroContratoTpz}}</v-card-subtitle>

                <v-row>
                  <v-col
                    cols="2"
                    class="ml-3"
                  >
                    <v-row
                      sm="1"
                      v-if="modalidade.bandaRede"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2 mb-3"
                        label
                        small
                        outlined
                      >
                        {{$vuetify.lang.t('$vuetify.BANDA_PELA_REDE')}}
                      </v-chip>
                    </v-row>

                    <v-row
                      sm="1"
                      v-if="modalidade.demonstracao"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2  mb-3"
                        label
                        small
                        outlined
                      >
                        {{$vuetify.lang.t('$vuetify.DEMONSTRACAO')}}
                      </v-chip>
                    </v-row>
                    <v-row
                      sm="2"
                      v-if="modalidade.internet"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2  mb-3"
                        label
                        small
                        outlined
                      >
                        Internet
                      </v-chip>
                    </v-row>

                    <v-row
                      sm="2"
                      v-if="modalidade.gerencia"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2 mb-3"
                        label
                        small
                        outlined
                      >
                        {{$vuetify.lang.t('$vuetify.GERENCIA')}}
                      </v-chip>
                    </v-row>

                    <v-row
                      :cols="!$vuetify.breakpoint.xs?5:4"
                      sm="2"
                      v-if="modalidade.intranet"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2 mb-3"
                        label
                        small
                        outlined
                      >
                        Intranet
                      </v-chip>
                    </v-row>
                    <v-row
                      :cols="!$vuetify.breakpoint.xs?5:4"
                      sm="2"
                      v-if="modalidade.iptv"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2 mb-3"
                        label
                        small
                        outlined
                      >
                        Iptv
                      </v-chip>
                    </v-row>
                    <v-row
                      :cols="!$vuetify.breakpoint.xs?5:4"
                      sm="2"
                      v-if="modalidade.voip"
                    >
                      <v-chip
                        color="blue darken-2"
                        class="ml-0 mr-2 mb-3"
                        label
                        small
                        outlined
                      >
                        Voip
                      </v-chip>
                    </v-row>
                  </v-col>

                  <v-col class="mt-2 ml-3">
                    <v-row
                      class="mt-0 ml-1"
                      :class="{'pl-10 pt-3 ml-n5':$vuetify.breakpoint.xs}"
                    >

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3 ml-n3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.DESCRICAO')"
                          :value="modalidade.descricao?modalidade.descricao:'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3 ml-0"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.VALOR_LOCACAO')"
                          :value="modalidade.valorLocacao ? Intl.NumberFormat('pt-BR', 
                          { style: 'currency', currency: $getCurrencySymbol(modalidade.contrato.moeda) }).
                                format(modalidade.valorLocacao):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.VALOR_ASSISTENCIA')"
                          :value="modalidade.valorAssistencia ? Intl.NumberFormat('pt-BR', 
                          { style: 'currency', currency: $getCurrencySymbol(modalidade.contrato.moeda) }).
                                format(modalidade.valorAssistencia):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.VALOR_TELECOM')"
                          :value="modalidade.valorTelecom ? Intl.NumberFormat('pt-BR', 
                          { style: 'currency', currency: $getCurrencySymbol(modalidade.contrato.moeda) }).
                                format(modalidade.valorTelecom):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>

                    <v-row
                      class="mt-0 ml-1"
                      :class="{'pl-10 pt-3 ml-n5':$vuetify.breakpoint.xs}"
                    >
                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3 ml-n3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.DOWNLOAD_MAXIMO_CONTRATADO')"
                          :value="modalidade.downloadContratado?modalidade.downloadContratado + ' ' + (modalidade.medida || 'Kbps') :'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.DOWNLOAD_TIPICO_CONTRATADO')"
                          :value="modalidade.downloadTipico?modalidade.downloadTipico + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.UPLOAD_MAXIMO_CONTRATADO')"
                          :value="modalidade.uploadContratado?modalidade.uploadContratado + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.UPLOAD_TIPICO_CONTRATADO')"
                          :value="modalidade.uploadTipico?modalidade.uploadTipico + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>

                    <v-row
                      class="mt-0 ml-1"
                      :class="{'pl-10 pt-3 ml-n5':$vuetify.breakpoint.xs}"
                    >
                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3 ml-n3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.DOWNLOAD_MAXIMO_PROJETADO')"
                          :value="modalidade.downloadProjetado?modalidade.downloadProjetado + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.DOWNLOAD_CIR_PROJETADO')"
                          :value="modalidade.downloadCir?modalidade.downloadCir + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.UPLOAD_MAXIMO_PROJETADO')"
                          :value="modalidade.uploadProjetado?modalidade.uploadProjetado + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-2 ml-7"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.UPLOAD_CIR_PROJETADO')"
                          :value="modalidade.uploadCir?modalidade.uploadCir + ' ' + (modalidade.medida || 'Kbps'):'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>

                    <v-row
                      class="mt-0 ml-1"
                      :class="{'pl-10 pt-3 ml-n5':$vuetify.breakpoint.xs}"
                    >
                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-3 ml-n3"
                        :class="{'col-6 ml-0':$vuetify.breakpoint.xs}"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.OUTROS')"
                          :value="modalidade.outros?modalidade.outros:'--'"
                          justify="start"
                          style="width:350px;"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-divider class="mt-0"></v-divider>

                <v-card-actions class="mb-n3">
                  <TooltipButton
                    v-if="$hasPermission('MODALIDADES-NOVA', [])"
                    :label="$vuetify.lang.t('$vuetify.EDITAR')"
                    :message="$vuetify.lang.t('$vuetify.EDITAR_MODALIDADE')"
                    :event="editModalidade"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText=true
                    :object="modalidade"
                  ></TooltipButton>
                </v-card-actions>
              </v-expansion-panel-content>

            </v-expansion-panel>
          </v-expansion-panels>

        </v-row>
        <v-row justify="center">
          <v-progress-circular
            v-if="isLoading"
            :size="30"
            :width="4"
            color="blue darken-2"
            indeterminate
            class="ml-n2 mt-3 mb-n1 text-center"
          ></v-progress-circular>
        </v-row>
        <v-row
          justify="center"
          v-if="modalidades.length == 0 && !isLoading"
        >
          <v-lazy
            :options="{threshold: .6}"
            transition="slide-x-transition"
          >
            <WarningPanel
              v-if="!isLoading"
              :message="$vuetify.lang.t('$vuetify.NENHUMA_MODALIDADE')"
            > </WarningPanel>
          </v-lazy>
        </v-row>
      </div>
    </v-col>

    <ModalityFormDialog
      :dialog="showDialog"
      :modalidade="selectedModalidade"
      :close="closeDialog"
      :send="sendModalidade"
      :isLoading="isLoading"
      :showModalidadeAlreadyExists="showModalidadeAlreadyExists"
      :showWarning="showWarning"
      :warningMessage="warningMessage"
    ></ModalityFormDialog>
  </v-layout>

</template>

<script>

import WarningPanel from '../components/panels/WarningPanel';
import TooltipButton from '../components/TooltipButton';
import LabelValue from '../components/LabelValue';
import ModalityFormDialog from '../components/dialogs/ModalityFormDialog';

export default {
  components: {
    WarningPanel,
    TooltipButton,
    LabelValue,
    ModalityFormDialog,
  },
  methods: {
    editModalidade (modalidade) {

      this.selectedModalidade = Object.assign({}, modalidade);
      this.showDialog = true;
    },
    hasEmptyFields (modalidade) {
      return !modalidade.modalidade || !modalidade.contrato || !modalidade.descricao || !modalidade.medida;
    },
    sendModalidade (modalidade) {

      if (this.hasEmptyFields(modalidade)) {
        this.warningMessage =
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO_FALTANTE");
        this.showWarning = true;
        return;
      }

      this.showModalidadeAlreadyExists = false;
      this.isLoading = true;

      if (!modalidade.id) {
        this.$post('/modalidade/save', modalidade).then((response) => {

          if (!response.data) {
            this.showModalidadeAlreadyExists = true;
            return;
          }

          var element = document.getElementById("main");

          this.$vuetify.goTo(element, {
            duration: 200,
            offset: 25,
            easing: 'linear',
          })

          setTimeout(() => this.modalidades.unshift(response.data), 650)
          this.$root.$emit('invalidateFields')

          this.isLoading = false;
          this.showDialog = false;
          this.showWarning = false;
        });

        return;
      }

      this.$post('/modalidade/save', modalidade).then((modalidade) => {

        var vm = this;
        this.modalidades.forEach(function (m, i) {
          if (m.id == modalidade.data.id) {
            vm.modalidades[i] = modalidade.data;
          }
        })

        this.$root.$emit('invalidateFields', true)
        this.isLoading = false;
        this.showDialog = false;

      });

    },
    createModalidade () {
      this.selectedModalidade = {};
      this.showDialog = true;
    },
    closeDialog () {
      this.showDialog = false;
    },
    searchMore () {

      this.stickFilters();

      if (this.isLoding || this.noResult) {
        return;
      }

      if (document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.scrollHeight) {
        this.page++;
        this.search(this.page);
      }
    },
    search (page) {

      this.isLoading = true;
      if (!page) {
        this.page = 0
        this.modalidades = []
        this.noResult = false;
      }

      this.$get('/modalidade/busca', {
        searchText: this.searchText,
        page: this.page
      }).then((response) => {

        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.modalidades = this.modalidades.concat(response.data);
        this.isLoading = false;
      });

    },
    stickFilters () {
      if (document.documentElement.scrollTop > 95) {
        document.getElementById('filtro').style = "position:sticky; z-index:2; top:66px; box-shadow: 0 0 10px #333; border-radius: 15px;"
      } else if (document.documentElement.scrollTop < 60) {
        document.getElementById('filtro').style = ""
      }
    },
  },
  data: () => ({
    page: 0,
    isLoading: false,
    noResult: false,
    searchText: '',
    modalidades: [],
    showDialog: false,
    disabled: false,
    selectedModalidade: undefined,
    showModalidadeAlreadyExists: false,
    warningMessage: '',
    showWarning: false,
  }),
  created: function () {

    this.$root.$on('close-dialog', () => this.showWarning = false) 

    this.isLoading = true;
    this.$get('/modalidade/busca',
      { searchText: '', page: 0 }).
      then((response) => {
        this.modalidades = response.data;
        this.isLoading = false;
      });
  }
};
</script>
